<template>
  <div id="app">
    <Header />
      <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
        <router-view/>
      </transition>
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      prevHeight: 0,
    }
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto&family=Ubuntu&display=swap');

:root {
  --primary-ff: 'Ubuntu', 'Roboto', Helvetica, Arial, 'Open Sans', 'Helvetica Neue', 'Segoe UI',  sans-serif;
  --secondary-ff: 'Roboto', Helvetica, Arial, 'Open Sans', 'Helvetica Neue', 'Segoe UI',  sans-serif;
  --fs-05: 0.667em;
  --fs-1: 1em;
  --fs-2: 1.5em;
  --fs-3: 2.25em;
  --fs-4: 3.375em;
  --fs-05m: 0.64em;
  --fs-1m: 1em;
  --fs-2m: 1.25em;
  --fs-3m: 1.563em;
  --fs-4m: 1.953em;
  --br: 10px;
  --default-transition: 0.25s all ease-in-out;

  /* Color Scheme 1 */
  /*
  --color-bg: #fafafa;
  --color-fg: #fefefe;
  --color-title: #212121;
  --color-body: #4a4a4a;
  --color-accent-1: #c9c9c9;
  --color-accent-2: #717cfc;
  */

  /* Color Scheme Two */
  --color-bg: #f9f5f1;
  --color-fg: #8F8B87;
  --color-title: #312E2B;
  --color-body: #55524E;
  --color-accent-1: #C2BFBB;
  --color-accent-2: #717cfc;

  /* Color Scheme Three */
  /*
  --color-bg: #000;
  --color-title: #FFF;
  --color-body: #DDD;
  --color-accent-1: #00FF00;
   */
 }

#app {
  margin: 3em 1.5em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}

a {
  text-decoration: none;
  color: var(--color-body);
  transition: var(--default-transition);
}

.p-link {
  color: var(--color-body);
  position: relative;
  display: inline-block;
}

.p-link:before {
  content: "";
  position: absolute;
  bottom: 10%;
  left: 15%;
  width: 85%;
  height: 10%;
  border-radius: var(--br);
  z-index: -1;
  background-color: var(--color-accent-1);
  opacity: 1;
  transform: scaleX(1);
  transform-origin: left;
  transition: transform 0.35s ease-in-out;
  /* In-out Transition
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.35s ease-in-out;
  */
}

.p-link:hover:before {
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.35s ease-in-out;
  /* In-out Transition
  transform: scaleX(1);
  transform-origin: left
  */
}

.fade-enter-active, 
.fade-leave-active {
  transition: all 0.35s ease;
  overflow: hidden;
}

.fade-enter, 
.fade-leave-active {
  opacity: 0;
  transform: translateX(2em);
}

/* Tablet S */
@media (max-width: 630px) {
  .heading {
    font-size: var(--fs-4m);
  }
  #app {
    margin: 1.5em 1em;
  }

  .p-link:before {
    transform: scaleX(1);
  }
}

/* Desktop L*/
@media (min-width: 1700px){
  #app {
    margin: 3em 5em;
}
}
</style>
